import * as _ from 'lodash';
import { Component, enableProdMode, ViewContainerRef, ViewChild } from '@angular/core';
import { DxSchedulerComponent } from 'devextreme-angular';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { locale, loadMessages } from "devextreme/localization";
import notify from 'devextreme/ui/notify';
import { baseZIndex } from 'devextreme/ui/overlay';
import deMessages from "../../../../../assets/i18n/es.json";
import moment from 'moment';
import { IAppointment, SAppointment } from '../../../tasks-page/tasks/appoinment/appointment.interface';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { ITask, ITaskAppointmentFilter } from '../../../tasks-page/tasks/task.interface';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { AppointmentsService } from '../../../tasks-page/tasks/appoinment/appointment.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { FeaturesService } from '../../../features-page/features/features.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { TaskModalComponent } from '../../../tasks-page/tasks/task-modal/task-modal.component';


let self: any;

if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

@Component({
  selector: 'app-calendar-by-client',
  templateUrl: './calendar-by-client.component.html',
  styleUrls: ['./calendar-by-client.component.css'],
  providers: [],
})
export class CalendarByClientComponent {
  @ViewChild(DxSchedulerComponent) scheduler!: DxSchedulerComponent;
  appointmentsData: SAppointment[] = [];
  clients: IClient[] = [];
  clientsV: any[] = [];
  selectedTask: ITask = {};
  appointments: IAppointment[] = [];
  filter: ITaskAppointmentFilter = {
    sort: '',
    skip: 0,
    limit: 5000,
    filters: {
      startDate: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
      endDate: new Date(new Date().setHours(23, 59, 59, 999)).toISOString()
    },
  };
  loadingVisible = true;
  getMore: boolean = false;
  currentDate: Date = new Date();
  formItems = [];
  formOpening: any;
  settings: any = [];
  feature: any = [];

  form!: UntypedFormGroup;
  formC!: UntypedFormGroup;
  workers: IWorker[] = [];
  workersFilter!: [];
  clientsFilter!: [];
  submitted = false;
  statusFilter: string = "";
  colorStatusOpen: string = "";
  colorStatusScheduled: string = "";
  colorStatusInvoiced: string = "";
  colorStatusOnGoing: string = "";
  colorStatusCompleted: string = "";
  colorStatusCancelled: string = "";

  constructor(
    private _AppointmentService: AppointmentsService,
    private _ClientsService: ClientsService,
    private _WorkersService: WorkersService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _AuthService: AuthService,
    private _SettingsService: SettingsService,
    private _FeaturesService: FeaturesService,
    private _dialogService: DialogService,
    private fb: UntypedFormBuilder
  ) {
    self = this;
    loadMessages(deMessages);
    locale(navigator.language);
  }

  ngOnInit() {
    this.filter.company = this._AuthService.companyId();
    baseZIndex(900);
    setTimeout(() =>
      this.loadingVisible = false
      , 800);

    this._FeaturesService.getFeatures({ filters: { name: "Agenda" } }).subscribe((feature) => {
      this.feature = feature;
      this._SettingsService.getCompanySettingByFeature({ company: this._AuthService.companyId(), filters: { feature: feature[0]["_id"] } }).subscribe((settings) => {
        this.settings = settings;
        this.setStatusColor();
      });
    });

    this._ClientsService.getClients({ limit: 500, skip: 0, company: this._AuthService.companyId(), filters: { isDeleted: false } }).subscribe((clients) => {
      this.clients = clients;
      this.clients = _.orderBy(this.clients, ['firstname'], ['asc']);
      this.clients.forEach((a) => {
        let firstname = a.firstname ?? "";
        let lastname = a.lastname ?? "";
        this.clientsV.push({
          id: a._id,
          text: firstname + "\n" + lastname
        });
      })
      this.getAppointments();
    });

    this._WorkersService.getWorkers({ limit: 500, skip: 0, company: this._AuthService.companyId(), filters: { isDeleted: false } }).subscribe((workers) => {
      this.workers = workers;
      this.workers = _.orderBy(this.workers, ['lastname', 'firstname'], ['asc','asc']);
    });

    this.buildForm();

  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      workers: [],
    });
    this.formC = this.fb.group({
      clients: [],
    });
  }

  onSubmit() {
    this.submitted = true;
    this.filterAppointments();
  }

  resetFilter() {
    self.filter.filters.workers = [];
    this.workersFilter = [];
    this.appointments = [];
    notify(`Cargando...` + '', "info", 800);
    this.getAppointments();
  }

  resetFilterC() {
    self.filter.filters.clients = [];
    this.clientsFilter = [];
    this.appointments = [];
    this.clientsV = [];
    this.clients.forEach((a) => {
      let firstname = a.firstname ?? "";
      let lastname = a.lastname ?? "";
      this.clientsV.push({
        id: a._id,
        text: firstname + "\n" + lastname
      });
    });
    notify(`Cargando...` + '', "info", 800);
    setTimeout(() => {
      this.getAppointments();
      this.scheduler.instance.getDataSource().reload();
    }, 500)
  }

  calculateDayFilter(e = new Date()) {
    let start = new Date(e.setHours(0, 0, 0, 0)).toISOString(),
      end = new Date(e.setHours(23, 59, 59, 999)).toISOString();
    self.filter.filters.startDate = start;
    self.filter.filters.endDate = end;
  }

  getAppointments(e?: any) {
    if (e) {
      this.calculateDayFilter(e)
    };
    this.appointmentsData = [];
    this._AppointmentService.getAppointments(this.filter).subscribe((appointments: any) => {
      this.appointments = _.concat(this.appointments, appointments);  
      this.appointments.forEach((a) => {
        let cTitle = (a.task.title != null) ?  (a.category[0].name + " | " + a.task.title) :  a.category[0].name;
        this.appointmentsData.push({
          text: a.title ?? "",
          startDate: new Date(a.startDate || ''),
          endDate: new Date(a.endDate || ''),
          color: this.getColor(a.task['status']),
          task: a.task,
          client: a.task.client,
          worker: a.task.workers ?? null,
          workers: a.workers.map((e: any) => (e.lastname ?? "" + " " + e.firstname ?? "")),
          cTitle: cTitle,
        })
      });
      this.getMore = appointments.length >= self.filter.limit ? true : false;
    });
  }  
  
  getColor(status: any) {
    switch (status) {
      case 'OPEN': 
      case 'QUOTED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_OPEN_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'ONGOING': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_ONGOING_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'SCHEDULED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_SCHEDULED_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'INVOICED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_INVOICED_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'COMPLETED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_COMPLETED_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'CANCELLED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_CANCELLED_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      default: {
        break;
      }
    }
  }

  setStatusColor() {
    let open = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_OPEN_COLOR);
    this.colorStatusOpen = open[0].companySetting != null ? open[0].companySetting.value : open[0].defaultValue;

    let scheduled = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_SCHEDULED_COLOR);
    this.colorStatusScheduled = scheduled[0].companySetting != null ? scheduled[0].companySetting.value : scheduled[0].defaultValue;

    let invoiced = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_INVOICED_COLOR);
    this.colorStatusInvoiced = invoiced[0].companySetting != null ? invoiced[0].companySetting.value : invoiced[0].defaultValue;

    let ongoing = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_ONGOING_COLOR);
    this.colorStatusOnGoing = ongoing[0].companySetting != null ? ongoing[0].companySetting.value : ongoing[0].defaultValue;

    let completed = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_COMPLETED_COLOR);
    this.colorStatusCompleted = completed[0].companySetting != null ? completed[0].companySetting.value : completed[0].defaultValue;

    let cancelled = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_CANCELLED_COLOR);
    this.colorStatusCancelled = cancelled[0].companySetting != null ? cancelled[0].companySetting.value : cancelled[0].defaultValue;
  }

  loadMore() {
    if (this.getMore && !this.loadingVisible) {
      self.filter.skip += self.filter.limit;
      this.getAppointments();
    }
  }

  filterAppointments() {
    self.filter.filters.workers = this.workersFilter;
    self.filter.filters.clients = this.clientsFilter;
    self.filter.filters.status = this.statusFilter;
    if(this.clientsFilter.length > 0){
      this.clientsV = [];
      this.clients.forEach((a) => {
        let firstname = a.firstname ?? "";
        let lastname = a.lastname ?? "";
        this.clientsV.push({
          id: a._id,
          text: firstname + "\n" + lastname
        });
      });
      let filterT = self.filter.filters.clients;
      this.clientsV = this.clientsV.filter(function(item){
        return filterT.includes(item.id)
      });
    }
    notify(`Cargando...` + '', "info", 800);
    setTimeout(() => {
      this.appointments = [];
      this.getAppointments();
      this.scheduler.instance.getDataSource().reload();
    }, 1000)
  }

  showToast(event: any, value: any, type: any, time = 800) {
    notify(`${event} "${value}"` + ' task', type, time);
  }

  onOptionChanged(e: any) {

    if (e.component.option('currentView') == 'timelineDay') {
      try {
        var curr = e.value;
        if (curr instanceof Date) {
          notify(`Cargando...` + '', "info", 800);
          setTimeout(() => {
            this.appointments = [];
            this.getAppointments(curr);
            this.scheduler.instance.getDataSource().reload();
            //e.component.scrollToTime(new Date(curr).getHours(), 0, new Date(curr).getDate());
          }, 500);
        }
      } catch (e) {

      }
    }

    if (e.component.option('currentView') == 'workWeek' && e.name == 'selectedCellData') {
      
      try {

          var firstday = new Date(e.component.getStartViewDate());
          var lastday = new Date(e.component.getEndViewDate());

          //refactor
          if(firstday.getDate() == lastday.getDate()){
            self.filter.filters.startDate = new Date(firstday.setDate( firstday.getDate() - 7) ).toISOString();
            self.filter.filters.endDate = new Date(lastday.setDate( lastday.getDate() + 7) ).toISOString();
          }else{
            self.filter.filters.startDate = moment(firstday).subtract(14, 'days').toISOString();
            self.filter.filters.endDate = moment(lastday).add(14, 'days').toISOString();
          }
          notify(`Cargando...` + '', "info", 800);
          setTimeout(() => {
            this.appointments = [];
            this.getAppointments();
            this.scheduler.instance.getDataSource().reload();
            //e.component.scrollToTime(7, 0, curr.getDate());
          }, 1000);

      } catch (e) {
        
      }

    }

    if (e.name == 'currentDate' && e.component.option('currentView') == 'Día') {
      try {
        var curr = e.value;
        if (curr instanceof Date) {
          notify(`Cargando...` + '', "info", 800);
          setTimeout(() => {
            this.appointments = [];
            this.getAppointments(curr);
            this.scheduler.instance.getDataSource().reload();
            //e.component.scrollToTime(new Date(curr).getHours(), 0, new Date(curr).getDate());
          }, 500);
        }
      } catch (e) {

      }
    }

  }

  onContentReady(e: any) {
    let hours = new Date().getHours();
    if (e.component.option('currentView') == 'timelineDay') {
      setTimeout(() => {
        e.component.scrollToTime(hours, 0, undefined);
      }, 1000);
    }
  }

  onAppointmentFormOpening(e: any) {
    const that = this;
    e.popup.option('showTitle', true);
    e.popup.option('title', e.appointmentData.text ?
      e.appointmentData.text :
      'cita');

    let form = e.form;
    this.formOpening = form;
    let formItems = form.option('items');

    this.formItems = formItems;

    if (e.appointmentData.task != undefined) {
      this.selectedTask = e.appointmentData.task;
    } else {
      this.selectedTask = {};
    }

    if (e.appointmentData.task != undefined) {
      this.openEditTaskModal();
    }

  }

  openEditTaskModal() {
    this.openTasksModalEdit(this.selectedTask);
  }

  openTasksModalEdit(task?: ITask, readOnly: boolean = false) {

    setTimeout(() => {
      //cochino pero funciona
      let element = document.getElementsByClassName('dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text dx-popup-cancel')[0];
      element.setAttribute('id', 'btn-close');
      document.getElementById('btn-close')?.click();
    });

    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.panelClass = 'calendar-task';
    config.viewContainerRef = this._viewContainerRef;
    config.disableClose = true;
    config.hasBackdrop = true;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = task;
    // self.dialogRef.componentInstance.readOnly = readOnly;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showStart = true;
    self.dialogRef.componentInstance.showEnd = true;
    self.dialogRef.afterClosed().subscribe((result: any) => {
      if (this.selectedTask._id != undefined && result._id != undefined) {
        this.selectedTask = result;
      }
      if (result._id != undefined) {
        this.selectedTask = result;
      }
      self.dialogRef = null;
    });
    self.dialogRef.backdropClick().subscribe(() => {
      self.dialogRef = null;
      setTimeout(() => {
        //cochino pero funciona
        let element = document.getElementsByClassName('dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text dx-popup-cancel')[0];
        element.setAttribute('id', 'btn-close');
        document.getElementById('btn-close')?.click();
      });
    });
  }

}

